import {useEffect, useState} from 'react';
import './style.css';
import {
    CONSENT_STORAGE_KEY,
    applyTrackingConsent,
    getStoredConsent,
    initializeConsentMode,
} from '../../analytics';
import {useTranslations} from '../../lang';

export default function CookieConsent() {
    const [consent, setConsent] = useState(getStoredConsent);
    const {translate} = useTranslations();

    useEffect(() => {
        initializeConsentMode();
        if (consent) applyTrackingConsent(consent);
    }, [consent]);

    const choose = (value) => {
        try {
            window.localStorage.setItem(CONSENT_STORAGE_KEY, value);
        } catch {
            // The in-memory choice still controls tracking for this page load.
        }
        setConsent(value);
    };

    if (consent) {
        return null;
    }

    return (
        <div className="cookie-consent-backdrop">
            <section
                aria-describedby="cookie-consent-description"
                aria-labelledby="cookie-consent-title"
                aria-modal="true"
                className="cookie-consent-modal"
                role="dialog"
            >
                <h2 id="cookie-consent-title">{translate('Cookievoorkeuren')}</h2>
                <p id="cookie-consent-description">
                    {translate('We gebruiken noodzakelijke cookies om Oogst.app goed te laten werken. Met jouw toestemming gebruiken we ook cookies voor statistieken en marketing om de website te verbeteren.')}
                </p>
                <div className="cookie-consent-actions">
                    <button className="cookie-consent-secondary" onClick={() => choose('denied')} type="button">
                        {translate('Alleen noodzakelijk')}
                    </button>
                    <button className="cookie-consent-primary" onClick={() => choose('granted')} type="button">
                        {translate('Alles accepteren')}
                    </button>
                </div>
                <a href="/privacy-policy">{translate('Lees ons privacybeleid')}</a>
            </section>
        </div>
    );
}

export {CONSENT_STORAGE_KEY};
